import { useRpcCall } from "@scayle/storefront-nuxt/composables";
import { ref, computed } from "vue";
import {
  isCategorySuggestion,
  isNavigationItemSuggestion,
  isProductSuggestion
} from "../utils/search.js";
export function useSearch({ with: _withParams } = {}) {
  const getSearchSuggestionsRpc = useRpcCall("getSearchSuggestions");
  const resolveSearchRpc = useRpcCall("resolveSearch");
  const error = ref();
  const status = ref("idle");
  const data = ref();
  const searchQuery = ref("");
  const resetSearch = () => {
    searchQuery.value = "";
    data.value = { suggestions: [] };
    status.value = "success";
  };
  const getSearchSuggestions = async () => {
    status.value = "pending";
    if (!searchQuery.value) {
      resetSearch();
      return;
    }
    try {
      data.value = await getSearchSuggestionsRpc({
        term: String(searchQuery.value),
        ..._withParams ? { with: _withParams } : {}
      });
    } catch (e) {
      error.value = e;
    } finally {
      status.value = error.value ? "error" : "success";
    }
  };
  const resolveSearch = async () => {
    if (!searchQuery.value) {
      return;
    }
    return await resolveSearchRpc({
      term: searchQuery.value,
      ..._withParams ? { with: _withParams } : {}
    });
  };
  const allSuggestions = computed(() => data?.value?.suggestions ?? []);
  const products = computed(() => {
    return allSuggestions.value.filter(isProductSuggestion);
  });
  const categories = computed(() => {
    return allSuggestions.value.filter(isCategorySuggestion);
  });
  const navigationItems = computed(
    () => allSuggestions.value.filter(isNavigationItemSuggestion)
  );
  const totalCount = computed(() => {
    return products.value.length + categories.value.length + navigationItems.value.length;
  });
  const hasSuggestions = computed(() => !!totalCount.value);
  const hasSearchQuery = computed(() => !!searchQuery.value?.length);
  return {
    data,
    error,
    status,
    resetSearch,
    getSearchSuggestions,
    resolveSearch,
    searchQuery,
    products,
    categories,
    navigationItems,
    hasSuggestions,
    totalCount,
    hasSearchQuery
  };
}
